import { Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { ArrowLeft, Printer, MapPin, Video, MessageCircle, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CLINIC } from "@/constants/clinic";
import { useClinics } from "@/hooks/useClinics";

export default function PosterPage() {
  const clinics = useClinics();
  const bookingUrl = `${window.location.origin}/#book`;
  return (
    <div className="min-h-screen bg-slate-100 print:bg-white py-8 print:py-0" data-testid="poster-page">
      <div className="no-print max-w-[210mm] mx-auto px-4 mb-6 flex items-center justify-between">
        <Button asChild variant="ghost" data-testid="poster-back-btn"><Link to="/admin"><ArrowLeft className="mr-1 h-4 w-4" /> Dashboard</Link></Button>
        <Button className="rounded-full" onClick={() => window.print()} data-testid="poster-print-btn"><Printer className="mr-2 h-4 w-4" /> Print poster</Button>
      </div>
      <div className="poster-sheet mx-auto bg-white shadow-xl print:shadow-none w-[210mm] min-h-[297mm] p-[14mm] flex flex-col items-center text-center" data-testid="poster-sheet">
        <p className="text-sm font-semibold uppercase tracking-[0.3em] text-secondary">Book your appointment online</p>
        <h1 className="mt-4 text-5xl font-bold tracking-tight text-[#1A252C]">{CLINIC.doctor}</h1>
        <p className="mt-3 text-xl text-primary font-medium">{CLINIC.title}</p>
        <p className="mt-2 text-sm text-muted-foreground">{CLINIC.qualifications.join(" · ")}</p>
        <div className="mt-10 rounded-[2rem] border-4 border-primary p-8 bg-white">
          <QRCodeSVG value={bookingUrl} size={300} level="M" fgColor="#312E81" data-testid="poster-qr" />
        </div>
        <p className="mt-6 text-3xl font-display font-extrabold tracking-widest text-primary">SCAN TO BOOK</p>
        <p className="mt-2 text-muted-foreground">Point your phone camera at the code — no app needed</p>
        <p className="mt-1 text-xs text-muted-foreground break-all" data-testid="poster-url">{bookingUrl}</p>
        <div className="mt-10 w-full grid grid-cols-2 gap-3 text-left">
          {clinics.map((c) => (
            <div key={c.id} className="rounded-2xl bg-accent/60 p-4" data-testid={`poster-clinic-${c.id}`}>
              <p className="flex items-center gap-2 font-semibold text-[#1A252C] text-sm">
                {c.type === "online" ? <Video className="h-4 w-4 text-primary" /> : <MapPin className="h-4 w-4 text-primary" />}{c.name}
              </p>
              <p className="mt-1 text-xs text-muted-foreground">{c.schedule}</p>
            </div>
          ))}
        </div>
        <div className="mt-6 w-full rounded-2xl bg-amber-50 border border-amber-200 py-3 font-semibold text-[#1F2937]">30% off for women's on Sundays · consultation fees</div>
        <div className="mt-auto pt-8 flex flex-wrap justify-center gap-x-8 gap-y-2 text-lg font-medium text-[#1A252C]">
          <p className="flex items-center gap-2" data-testid="poster-call"><Phone className="h-5 w-5 text-primary" /> Appointments: +91 {CLINIC.phone}</p>
          <p className="flex items-center gap-2" data-testid="poster-whatsapp"><MessageCircle className="h-5 w-5 text-[#25D366]" /> WhatsApp +91 {CLINIC.whatsapp}</p>
        </div>
      </div>
    </div>
  );
}
